export const getOnFilterChipDelete =
  (handleDeleteFilter?: (id: string) => () => void) => (key: string) => {
    return handleDeleteFilter ? handleDeleteFilter(key) : undefined;
  };
